import { Theme } from '@material-ui/core'

export const ActionButtonStyle: (theme: Theme) => {
    background: string,
    color: string
} | undefined = (t) => undefined